"use client";

import React from "react";
import { ChartBar, Shield, Zap } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const processes = [{
  id: "measure",
  title: "Measure",
  description: "We begin with comprehensive lab testing and biometric analysis to establish your unique baseline and identify specific areas for optimization.",
  icon: ChartBar
}, {
  id: "optimize",
  title: "Optimize",
  description: "Based on your data, we design a targeted protocol utilizing IV therapy, vitamin injections, and advanced wellness treatments to elevate your health.",
  icon: Zap
}, {
  id: "maintain",
  title: "Maintain",
  description: "Achieve lasting vitality through ongoing self-care practices, membership benefits, and periodic reassessments to ensure sustained peak performance.",
  icon: Shield
}];
export default function ServiceProcessGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="serviceprocessgrid" className="bg-background relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_center,var(--color-green-accent)_0%,transparent_70%)] opacity-[0.03]" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default text-foreground mb-4 text-3xl font-light tracking-tight md:text-4xl lg:text-5xl">
            The M / O Protocol
          </h2>
          <p className="font-sans text-muted-foreground mx-auto max-w-2xl text-lg">
            A systematic approach to ethereal precision and lasting vitality.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-12">
          {processes.map((process, i) => {
          const Icon = process.icon;
          return <div key={process.id} data-index={i} className={`transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="bg-background/60 border-border/50 hover:shadow-md relative h-full overflow-hidden rounded-2xl backdrop-blur-md transition-shadow duration-300">
                  {}
                  <div className="absolute top-0 right-0 left-0 h-[1px] bg-[var(--color-green-accent)] opacity-80" />

                  <CardHeader className="pb-4 pt-8">
                    <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[var(--color-green-accent)]/10">
                      <Icon className="h-7 w-7 text-[var(--color-green-accent)]" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-foreground text-2xl font-medium tracking-tight">
                      {process.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="font-sans text-muted-foreground leading-relaxed">
                      {process.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}